module.exports = __webpack_public_path__ + "static/media/image4.f89b00f9.jpg";